import React from 'react';

import { ModalProps } from '../../../../components/Modal';
import { DoctorScheduling } from '../../../../components/Icons/DoctorScheduling';
import { SimpleModal } from '../../../../components/SimpleModal';

export type SystemUnavailableProps = Pick<ModalProps, 'visible' | 'onClose'>;

export const ReturnsAlredyScheduledModal: React.FC<SystemUnavailableProps> = ({ visible, onClose }) => {
  return (
    <SimpleModal
      visible={visible}
      onClose={onClose}
      title="Suas consultas de retorno já foram agendadas ou realizadas"
      subtitle="Você já agendou ou realizou todas as consultas de retorno com o clínico geral e a equipe multidisciplinar. <br /><br /> Para mais informações, consulte a sua agenda com o token enviado ao seu e-mail."
      mainIcon={<DoctorScheduling />}
    />
  );
};
